import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/ai/admin/useAdminAiFeedbackQueryKeys.ts
var t = e("admin-ai-feedback", {
	summary: (e) => ["summary", e],
	timeseries: (e) => ["timeseries", e],
	comments: () => ["comments"]
});
//#endregion
export { t as adminAiFeedbackQueryKeys };
